module.exports = __webpack_public_path__ + "static/media/contact_us_french.b431bb59.jpg";